import Vue from "vue";
import VueRouter from "vue-router";
import homeIndex from "@/views/home/index1.vue";
// import energy from "@/views/home/energych.vue";
// import energy from "@/views/home/energyss.vue";
// import energy from "@/views/home/energyzlyd.vue";
// import energy from "@/views/home/energxyx.vue";
// import energy from "@/views/home/energjx.vue";
// import energy from "@/views/home/energrfjc.vue";
// import energy from "@/views/home/energxjjh.vue";
// import energy from "@/views/home/energgqy.vue";
// import energy from "@/views/home/energgbqm.vue";
// import energy from "@/views/home/energztqd.vue";
// import energy from "@/views/home/energyltzm.vue";
// import energy from "@/views/home/energsmjt.vue";
Vue.use(VueRouter);

const routes = [
    
	//首页
    // {
    //     path: "/",
    //     redirect: 'energy',
    //     meta:{
    //          title: '',
    //          keepAlive:true
    //     }
    // },
    {
        path: "/",
        redirect: 'homeIndex',
        meta:{
             title: '',
             keepAlive:true
        }
    },
    // {
    //   path: "/homeIndex1",
    //   name: "homeIndex1",
    // 	meta:{
    // 		title: '货满满物流业务实况数据大屏',
    // 		keepAlive:true
    // 	},
    //   component: () =>
    //     import("../views/home/index.vue")
    // },
    
   {
     path: "/homeIndex",
     name: "homeIndex",
   	meta:{
   		title: '货满满物流业务实况数据大屏',
   		keepAlive:true
   	},
     component: () =>
       import("../views/home/index1.vue")
   },
   
   
   // {
   //   path: "/homeIndex2",
   //   name: "homeIndex2",
   // 	meta:{
   // 		title: '货满满物流业务实况数据大屏',
   // 		keepAlive:true
   // 	},
   //   component: () =>
   //     import("../views/home/index2.vue")
   // },
   // {
   //   path: "/homeIndex3",
   //   name: "homeIndex3",
   // 	meta:{
   // 		title: '货满满物流业务实况数据大屏',
   // 		keepAlive:true
   // 	},
   //   component: () =>
   //     import("../views/home/index3.vue")
   // },
   // {
   //   path: "/homeIndex4",
   //   name: "homeIndex4",
   // 	meta:{
   // 		title: '货满满物流业务实况数据大屏',
   // 		keepAlive:true
   // 	},
   //   component: () =>
   //     import("../views/home/index4.vue")
   // },
   // {
   //   path: "/tpfIndex",
   //   name: "tpfIndex",
   // 	meta:{
   // 		title: '货满满物流车辆碳排放数据',
   // 		keepAlive:true
   // 	},
   //   component: () =>
   //     import("../views/home/tpfindex.vue")
   // },
   
   // {
   //   path: "/energy",
   //   name: "energy",
   // 	meta:{
   // 		title: '货满满物流新能源车辆实况',
   // 		keepAlive:true
   // 	},
   //   component: () =>
   //     import("../views/home/energy.vue")
   // },
   
   // {
   //   path: "/energy",
   //   name: "energy",
   // 	meta:{
   // 		title: '中通氢电物流新能源车辆实况',
   // 		keepAlive:true
   // 	},
   //   component: () =>
   //     import("../views/home/energztqd.vue")
   // },
   
   // {
   //   path: "/energy",
   //   name: "energy",
   // 	meta:{
   // 		title: '鑫业兴物流新能源车辆实况',
   // 		keepAlive:true
   // 	},
   //   component: () =>
   //     import("../views/home/energxyx.vue")
   // },
   
   // {
   //   path: "/energy",
   //   name: "energy",
   // 	meta:{
   // 		title: '鲸喜物流新能源车辆实况',
   // 		keepAlive:true
   // 	},
   //  component: () =>
   //     import("../views/home/energjx.vue")
   // },
   
   // {
   //   path: "/energy",
   //   name: "energy",
   // 	meta:{
   // 		title: '瑞锋建材物流新能源车辆实况',
   // 		keepAlive:true
   // 	},
   //  component: () =>
   //     import("../views/home/energrfjc.vue")
   // },
   // {
   //   path: "/energy",
   //   name: "energy",
   // 	meta:{
   // 		title: '甘泉云物流新能源车辆实况',
   // 		keepAlive:true
   // 	},
   //  component: () =>
   //     import("../views/home/energxjjh.vue")
   // },
   
   
   // {
   //   path: "/energy",
   //   name: "energy",
   // 	meta:{
   // 		title: '新疆京泓物流新能源车辆实况',
   // 		keepAlive:true
   // 	},
   //  component: () =>
   //     import("../views/home/energgqy.vue")
   // },
   
   // {
   //   path: "/energy",
   //   name: "energy",
   // 	meta:{
   // 		title: '高兵汽贸新能源车辆实况',
   // 		keepAlive:true
   // 	},
   //  component: () =>
   //     import("../views/home/energgbqm.vue")
   // },
   
   // {
   //   path: "/energy",
   //   name: "energy",
   // 	meta:{
   // 		title: '川海物流新能源车辆实况',
   // 		keepAlive:true
   // 	},
   //   component: () =>
   //     import("../views/home/energych.vue")
   // },
   
   // {
   //   path: "/energy",
   //   name: "energy",
   // 	meta:{
   // 		title: '速讯智慧物流新能源车辆实况',
   // 		keepAlive:true
   // 	},
   //   component: () =>
   //     import("../views/home/energyss.vue")
   // },
   
   // {
   //   path: "/energy",
   //   name: "energy",
   // 	meta:{
   // 		title: '智连优达物流新能源车辆实况',
   // 		keepAlive:true
   // 	},
   //   component: () =>
   //     import("../views/home/energyzlyd.vue")
   // },
   // {
   //   path: "/energy",
   //   name: "energy",
   // 	meta:{
   // 		title: '绿途智贸物流新能源车辆实况',
   // 		keepAlive:true
   // 	},
   //   component: () =>
   //     import("../views/home/energyltzm.vue")
   // },
   
   // {
   //   path: "/energy",
   //   name: "energy",
   // 	meta:{
   // 		title: '陕煤集团零碳智慧物流运营平台',
   // 		keepAlive:true
   // 	},
   //   component: () =>
   //     import("../views/home/energsmjt.vue")
   // },
   
   {
     path: "/energy",
     name: "energy",
   	meta:{
   		title: '货满满物流业务实况数据大屏',
   		keepAlive:true
   	},
     component: () =>
       import("../views/home/energy.vue")
   },
   
   // {
   //   path: "/skIndex",
   //   name: "skIndex",
   // 	meta:{
   // 		title: '货满满物流业务实况数据大屏',
   // 		keepAlive:true
   // 	},
   //   component: () =>
   //     import("../views/home/skindex.vue")
   // },
   {
     path: "/detail",
     name: "detail",
   	meta:{
   		title: '车辆运输数据',
   		keepAlive:false
   	},
     component: () =>
       import("../views/home/detail.vue")
   },
   
   // {
   //   path: "/sksjindex",
   //   name: "sksjindex",
   // 	meta:{
   // 		title: '货满满物流业务实况数据大屏',
   // 		keepAlive:false
   // 	},
   //   component: () =>
   //     import("../views/home/sksjindex.vue")
   // },
    //登录
    {
      path: "/login",
      name: "login",
    	meta:{
    		title: '登录',
    		keepAlive:false
    	},
      component: () =>
        import("../views/login.vue")
    },
    {
      path: "/modifypassword",
      name: "modifypassword",
    	meta:{
    		title: '修改密码',
    		keepAlive:false
    	},
      component: () =>
        import("../views/modifyword.vue")
    },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
	scrollBehavior (to, from, savedPosition) {
	  return new Promise((resolve, reject) => {
	    setTimeout(() => {
	      resolve({ x: 0, y: 0 })
	    }, 1)
	  })
	},
  routes,
});
export default router;
